import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { authData } from 'src/app/util/auth';
import { errorHandler } from 'src/app/util/errorHandler';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-course-lecture-pass',
  templateUrl: './course-lecture-pass.component.html',
  styleUrls: ['./course-lecture-pass.component.scss']
})
export class CourseLecturePassComponent implements OnInit {

  constructor(private httpClient: HttpClient) { }

  session = '';
    semester = '';
    sessions: string[] = [];
    semesters: string[] = [];
    notification: any = {};
    sessionAndSemester: any = {};
    _check: any;
    
    loading = false;
    skeletonLoader = true;
    downloader: any = null;
  
    _auth = authData();
  
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this._auth.Token,
      }),
    };

  ngOnInit(): void {
    this.fetchSessionAndSemester();
  }

  fetchSessionAndSemester(): Promise<any> {
      this.loading = true;
      return this.httpClient
        .get(`${environment.BASE_URL}/courses/getSessionsAndSemesters`, this.httpOptions)
        .toPromise()
        .then((res: any) => {
          this.loading = false;
          this.skeletonLoader = false;
          if (res.Success) {
            this.sessionAndSemester = res.Data;
            this.sessions = res.Data.Sessions;
            this.semesters = res.Data.Semesters;
          } else {
            this.notification = {
              message: res.Message || "An error occurred.",
              error: true,
            };
          }
        })
        .catch((error) => {
          this.loading = false;
          this.skeletonLoader = false;
          this.notification = errorHandler(error);
        });
    }

     proceedToSelection(): void {
    if (!this.session || !this.semester) {
      this.notification = {
        message: "Please select both session and semester",
        error: true
      };
      return;
    }

    this.notification = {};
    this.generateLecturePass();
  }

  generateLecturePass(): void {
    this.loading = true;
    this.downloader = { loading: true };

    const baseUrl = `${environment.BASE_URL}/courses/generateLecturePass`;
    const params = `?session=${encodeURIComponent(this.session)}&semester=${encodeURIComponent(this.semester)}`;

    this.httpClient.get<any>(baseUrl + params, this.httpOptions).subscribe({
      next: (res) => {
        this.loading = false;

        if (res.Success && res.Data?.Data) {
          this.downloader = {
            loading: false,
            url: "data:application/pdf;base64," + res.Data.Data,
          };
          this.notification = {
            message: "Lecture pass generated successfully!",
            error: false,
          };
        } else if (res.Success && !res.Data?.Data) {
          this.downloader = null;
          this.notification = {
            message: "No lecture pass available for the selected session and semester",
            error: true,
          };
        } else {
          this.downloader = null;
          this.notification = {
            message: res.Message || "Failed to generate lecture pass",
            error: true,
          };
        }
      },
      error: (error) => {
        this.loading = false;
        this.downloader = null;

        if (error.status === 404) {
          this.notification = {
            message: "API endpoint not found. Please check the server configuration.",
            error: true,
          };
        } else if (error.status === 401) {
          this.notification = {
            message: "Authentication failed. Please login again.",
            error: true,
          };
        } else {
          this.notification = errorHandler(error);
        }
      },
    });
  }

    

}
